import { useContext } from 'react';
import { CustomAlarmsFormContext } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/contexts/custom-alarms-form.context';

export const useCustomAlarmsFormContext = () => {
    const context = useContext(CustomAlarmsFormContext);

    if (!context) {
        throw new Error('useCustomAlarmsFormContext must be used within a CustomAlarmsFormProvider');
    }

    return context;
};
